import styled from 'styled-components'
import { GreenBtn } from 'Stories/Button/Button.stories'

export const StyledButton = styled(GreenBtn)`
  > img {
    margin-right: 0.625rem;
    width: 1rem;
    height: 1rem;
  }
`
